angular.module('impactx.address').component('ixBasketAddressDialogInput', {
        bindings: {
            handoverAddress: '<',
            contactAddress: '<',
            invoiceAddress: '<',
            deliveryAddress: '<',
            headline: '@',
            openDialog: '&',
            remove: '&',
            isSelected: "=",
            hideBoxesIfNotSelected: "="
        },
        controller: 'IxBasketAddressDialogInputController',
        templateUrl: 'modules/address/templates/basket-address-dialog-input.tmpl.html'
    }
);